import messages from './messages';

const linkedSalesorderWouldBeLost = 'IsOnlyLinkForSalesOrder';
const hasItems = 'CannotDeleteFulfillmentPlanWithItems';
const invalidOrderGridStatus = 'InvalidOrderGridStatus';
const hasSalesOrderItems = 'HasSalesOrderItems';
export const unknownError = 'Unknown';

export const errorMessageFromCodeMap = {
  [linkedSalesorderWouldBeLost]: messages.loneActiveFulfillmentPlan,
  [hasItems]: messages.hasItems,
  [invalidOrderGridStatus]: messages.nonDeletableStatus,
  [hasSalesOrderItems]: messages.hasSalesOrderItems,
  [unknownError]: messages.unknownDeletionError,
};
